import { ApplicationRef, enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { enableDebugTools } from '@angular/platform-browser';

Date.prototype.toJSON = function() {
    if (null == this || undefined == this) {
        return '';
    }
    const dt = this as Date;
    dt.setMinutes(dt.getMinutes() - dt.getTimezoneOffset());
    return dt.toISOString();
};

if (environment.production) {
    enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule).then(moduleRef => {
    const applicationRef = moduleRef.injector.get(ApplicationRef);
    applicationRef.components.forEach(component => {
        enableDebugTools(component);
    });
})
    .catch(err => console.error(err));

